import { useContext, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { Portal, TxPinVerification, TxPinVerificationD3, TxPinVerificationD2 } from "src/component"
import { Design } from 'src/model'


export const PanicPinSetup: React.FC<any> = ({close}) => {
    const {API} = useContext(ApiContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const [panicPin, setPanicPin] = useState('')

    async function handleSubmit() {
        await API.setPanicPin(panicPin)
        close()
    }

    return (
        <>
            { institutionData.design === Design.DESIGN_1 ?
                <TxPinVerification
                    close={close}
                    onPinChange={(pin: string) => setPanicPin(pin)}
                    next={handleSubmit} 
                />
                : institutionData.design === Design.DESIGN_2 ?
                <Portal forcePortal>
                    <TxPinVerificationD2
                        close={close}
                        onPinChange={(pin: string) => setPanicPin(pin)}
                        next={handleSubmit} 
                    />
                </Portal>
                    : 
                        <Portal forcePortal>
                            <TxPinVerificationD3
                                close={close}
                                onPinChange={(pin: string) => setPanicPin(pin)}
                                next={handleSubmit} 
                            />
                        </Portal>
            }
        </>
    )
}